import { PropsWithChildren } from 'react';

import css from './styles.module.css';

/** Trailing content on the title line, such as a status badge. */
export function HeaderSuffix({ children }: PropsWithChildren) {
  return <span className={css.suffix}>{children}</span>;
}
